import { ValidatorFn, Validators } from '@angular/forms';
import { ItemTask } from '../interfaces/task-approvativo.model';
import { EditProductRow } from '../lib/task-detail/task-detail.model';

// Casi da autorizzare, elencati nella descrizione come «codice testo; codice testo»: qui il solo testo
export function taskAnomalies(description?: string | null): string[] {
  return (description ?? '')
    .split(';')
    .map(anomaly => anomaly.trim().replace(/^\d+\s+/, ''))
    .filter(anomaly => anomaly.length > 0);
}

// Decimali dei campi ERP: prezzo 4, provvigione 2, no profit e fuori premio interi
export function maxDecimals(decimals: number): ValidatorFn {
  return Validators.pattern(decimals > 0 ? new RegExp(`^\\d+(\\.\\d{1,${decimals}})?$`) : /^\d+$/);
}

// Righe per la modifica dal task: di ogni riga i soli campi cambiati, le righe tolte come eliminate
export function toEditProductRows(originalItems: ItemTask[], modifiedItems: ItemTask[]): EditProductRow[] {
  const modifiedItemsById = new Map(modifiedItems.map(item => [item.id, item]));
  const rows: EditProductRow[] = [];

  for (const original of originalItems) {
    const modified = modifiedItemsById.get(original.id);

    if (!modified) {
      rows.push({ idRigaCarrello: original.id, eliminata: true });
      continue;
    }

    const changes: Partial<EditProductRow> = {};

    if (modified.qtaImballi !== original.qtaImballi) changes.quantita = modified.qtaImballi;
    if (modified.prezzo !== original.prezzo) changes.prezzo = modified.prezzo;
    if (modified.pProvvigione !== original.pProvvigione) changes.percProvvigione = modified.pProvvigione;
    if (modified.pNoProfit !== original.pNoProfit) changes.percNoProfit = modified.pNoProfit;
    if (modified.pFuoriPremio !== original.pFuoriPremio) changes.percFuoriPremio = modified.pFuoriPremio;

    if (Object.keys(changes).length > 0) {
      rows.push({ idRigaCarrello: original.id, ...changes });
    }
  }

  return rows;
}
